import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import Head from "@/components/Head/index.vue";
import Pagination from "@/components/Pagination/index.vue";
import { defineComponent, reactive, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import { useStore } from "vuex";
export default defineComponent({
  name: "Evaluator",
  components: {
    Head: Head,
    Pagination: Pagination
  },
  setup: function setup() {
    var showtable = ref(true);
    var router = useRouter();
    var logo = ref(0);
    var totalNumTwo = ref(10);
    var tab = ref([{
      participant: "",
      participantName: "",
      participantStatus: 0
    }]);
    var route = useRoute();
    var namehu = ref("开始互评");
    var showid = ref(true);
    var self = ref(0);

    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var tableData = ref([{
      name: '自评'
    }]);
    var tablelist = ref([{
      participant: "",
      participantName: ""
    }]);
    var tabler = reactive({
      lis: [{
        participant: "",
        participantName: "",
        participantStatus: 0
      }]
    });
    var store = useStore();

    function selfpeopleDetail(_x) {
      return _selfpeopleDetail.apply(this, arguments);
    }

    function _selfpeopleDetail() {
      _selfpeopleDetail = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(id) {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["selfpeopleDetail"](id);

              case 2:
                res = _context.sent;

                if (res.code == 0) {
                  self.value = res.data.participantStatus;
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _selfpeopleDetail.apply(this, arguments);
    }

    if (route.query.id != "1") {
      selfpeopleDetail({
        listId: route.query.userId,
        userId: store.state.user.user.userId
      });
    }

    function pge(num) {
      var as = num * 10;
      tablelist.value = [];

      if (tab.value.length - 1 < num * 10) {
        as = tab.value.length;
      }

      for (var i = (num - 1) * 10; i < as; i++) {
        tablelist.value[i - (num - 1) * 10] = tab.value[i];
      }

      console.log(tablelist.value);
    }

    function changPageTwo(val) {
      console.log(val);

      if (route.query.id != "1") {
        if (val == 1) {
          showid.value = true;
        } else {
          showid.value = false;
        }
      }

      console.log(4444);
      pge(val);
    }

    function peoplelist(_x2) {
      return _peoplelist.apply(this, arguments);
    }

    function _peoplelist() {
      _peoplelist = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(id) {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["peoplelist"](id);

              case 2:
                res = _context2.sent;

                if (res.code == 0) {
                  tabler.lis = res.data;
                  tab.value = res.data;
                  totalNumTwo.value = res.data.length;
                  pge(1);
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _peoplelist.apply(this, arguments);
    }

    peoplelist({
      listId: route.query.userId,
      userId: store.state.user.user.userId
    });

    function show() {
      if (route.query.id == "1") {
        //书记评议
        showid.value = false;
        namehu.value = "开始评议";
      }
    }

    show();
    var listid = route.query.userId;

    function hisoryDelete() {
      router.push({
        path: 'answerQuestions',
        query: {
          logo: logo.value,
          listid: listid
        }
      });
    }

    function hisoryhuDelete(val) {
      if (val.participantStatus == 0) {
        if (route.query.id == "1") {
          logo.value = 2;
        } else {
          logo.value = 1;
        }

        router.push({
          path: 'answerQuestions',
          query: {
            logo: logo.value,
            listid: listid,
            huid: val.participant
          }
        });
      }
    }

    var listtit = reactive({
      title: '',
      createTime: "",
      endTime: ""
    });

    function questionDemocracy(_x3) {
      return _questionDemocracy.apply(this, arguments);
    }

    function _questionDemocracy() {
      _questionDemocracy = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(id) {
        var res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["questionDemocracy"](id);

              case 2:
                res = _context3.sent;

                if (res.code == 0) {
                  listtit.title = res.data.title;
                  listtit.createTime = res.data.createTime;
                  listtit.endTime = res.data.endTime; //  tableData.value = res.data
                }

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return _questionDemocracy.apply(this, arguments);
    }

    questionDemocracy(route.query.userId);
    return {
      tableData: tableData,
      tabler: tabler,
      hisoryDelete: hisoryDelete,
      showid: showid,
      namehu: namehu,
      peoplelist: peoplelist,
      tablelist: tablelist,
      hisoryhuDelete: hisoryhuDelete,
      selfpeopleDetail: selfpeopleDetail,
      self: self,
      listtit: listtit,
      changPageTwo: changPageTwo,
      totalNumTwo: totalNumTwo,
      showtable: showtable
    };
  }
});